import type { ActionInput } from "../ActionInput.js";
import {
  hasSection136Form,
  hasTriageForm,
  incidentIsActive,
  triageSelectionIsSection136,
  userIsIncidentOwner,
} from "../helpers.js";

type StartSection136Action = {
  canStart: boolean;
};

type EditSection136Action = {
  canEdit: boolean;
};

type Section136Actions = StartSection136Action & EditSection136Action;

function canStartSection136(actionInput: ActionInput): boolean {
  return (
    incidentIsActive(actionInput) &&
    userIsIncidentOwner(actionInput) &&
    hasTriageForm(actionInput) &&
    triageSelectionIsSection136(actionInput)
  );
}

function canEditSection136(actionInput: ActionInput): boolean {
  return (
    incidentIsActive(actionInput) &&
    userIsIncidentOwner(actionInput) &&
    hasTriageForm(actionInput) &&
    hasSection136Form(actionInput)
  );
}

export function calculateSection136Actions(
  actionInput: ActionInput,
): Section136Actions {
  return {
    canStart: canStartSection136(actionInput),
    canEdit: canEditSection136(actionInput),
  };
}
